/** Original action.meta from promise-middleware START/SUCCESS/ERROR wrappers. */
export const getAsyncActionMeta = action => action.meta?.action?.meta ?? {}

/**
 * Await a promise-middleware async action without leaking `.meta.action.payload`.
 * Browser returns the `_START` wrapper; server returns the promise directly.
 */
export const dispatchAsync = (dispatch, action) => {
  const result = dispatch(action)
  if (result && typeof result.then === 'function') return result
  const promise = result?.meta?.action?.payload
  if (promise && typeof promise.then === 'function') return promise
  return Promise.resolve(result)
}
